import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoginComponent } from './pages/login/login.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { HeaderComponent } from './components/header/header.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { ToastrModule } from "ngx-toastr";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { Globals } from './globals';
import { UsersComponent } from './pages/users/users.component';
import { RegistrationComponent } from './pages/users/registration/registration.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { DatatableComponent } from './components/datatable/datatable.component';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from './components/loader/loader.component';
import { from } from 'rxjs';
import { loggedInAccess } from './loggedInAccess';
import { CreateUserComponent } from './pages/users/create-user/create-user.component';
import { UserEditComponent } from './pages/users/user-edit/user-edit.component';
import { CreateProfileComponent } from './pages/users/create-profile/create-profile.component';
import { LanguageComponent } from './pages/system/language/language.component';
import { SystemParametersComponent } from './pages/system/system-parameters/system-parameters.component';
import { ModuleParametersComponent } from './pages/system/module-parameters/module-parameters.component';
import { RolesComponent } from './pages/roles/roles.component';

import { BasicDataComponent } from './pages/admission/basic-data/basic-data.component';
import { CountriesComponent } from './pages/system/countries/countries.component';
import { CreateCountryComponent } from './pages/system/countries/create-country/create-country.component';
import { UpdateCountryComponent } from './pages/system/countries/update-country/update-country.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { RegionsComponent } from './pages/system/regions/regions.component';
import { Section1Component } from './pages/admission/section1/section1/section1.component';
import { ProvincesComponent } from './pages/system/provinces/provinces.component';
import { CreateProvinceComponent } from './pages/system/provinces/create-province/create-province.component';
import { UpdateProvinceComponent } from './pages/system/provinces/update-province/update-province.component';
import { CreateRegionComponent } from './pages/system/regions/create-region/create-region.component';
import { UpdateRegionComponent } from './pages/system/regions/update-region/update-region.component';
import { Section2Component } from './pages/admission/section2/section2/section2.component';
import { Section3Component } from './pages/admission/section3/section3/section3.component';
import { PersonalInterviewComponent } from './pages/admission/personal-interview/personal-interview.component';
import { MedicalCheckComponent } from './pages/admission/medical-check/medical-check.component';
import { NewCandidateInquiryComponent } from './pages/admission/new-candidate-inquiry/new-candidate-inquiry.component';
import { EvaluateComponent } from './pages/admission/evaluate/evaluate.component';
import { CandEnglishTestComponent } from './pages/admission/cand-english-test/cand-english-test.component';
import { ApplicationStatusesComponent } from './pages/admission/application-statuses/application-statuses.component';
import { ApplicationMaritalStatusComponent } from './pages/admission/application-marital-status/application-marital-status.component';
import { CreateMaritalStatusComponent } from './pages/admission/application-marital-status/create-marital-status/create-marital-status.component';
import { UpdateMaritalStatusComponent } from './pages/admission/application-marital-status/update-marital-status/update-marital-status.component';
import { LiveWithComponent } from './pages/admission/live-with/live-with.component';
import { CreateLiveWithComponent } from './pages/admission/live-with/create-live-with/create-live-with.component';
import { UpdateLiveWithComponent } from './pages/admission/live-with/update-live-with/update-live-with.component';
import { ChronicDiseasesComponent } from './pages/admission/chronic-diseases/chronic-diseases.component';
import { CreateChronicDiseasesComponent } from './pages/admission/chronic-diseases/create-chronic-diseases/create-chronic-diseases.component';
import { UpdateChronicDiseasesComponent } from './pages/admission/chronic-diseases/update-chronic-diseases/update-chronic-diseases.component';
import { CreateAppStatusComponent } from './pages/admission/application-statuses/create-app-status/create-app-status.component';
import { UpdateAppStatusComponent } from './pages/admission/application-statuses/update-app-status/update-app-status.component';
import { MilitaryStatusComponent } from './pages/admission/military-status/military-status.component';
import { CreateMilitaryStatusComponent } from './pages/admission/military-status/create-military-status/create-military-status.component';
import { UpdateMilitaryStatusComponent } from './pages/admission/military-status/update-military-status/update-military-status.component';
import { FamilyMembersComponent } from './pages/admission/family-members/family-members.component';
import { CreateFmMemberComponent } from './pages/admission/family-members/create-fm-member/create-fm-member.component';
import { UpdateFmMemberComponent } from './pages/admission/family-members/update-fm-member/update-fm-member.component';
import { QuestionsComponent } from './pages/admission/questions/questions.component';
import { CreateQuestionComponent } from './pages/admission/questions/create-question/create-question.component';
import { UpdateQuestionComponent } from './pages/admission/questions/update-question/update-question.component';
import { CreateCityComponent } from './pages/system/cities/create-city/create-city.component';
import { UpdateCityComponent } from './pages/system/cities/update-city/update-city.component';
import { CitiesComponent } from './pages/system/cities/cities.component'
import { TestExcelComponent } from './pages/test-excel/test-excel.component';
import { RoleCreateComponent } from './pages/roles/role-create/role-create.component';
import { RoleUpdateComponent } from './pages/roles/role-update/role-update.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CandPreviewComponent } from './pages/admission/cand-preview/cand-preview.component';
import { CandCardComponent } from './pages/admission/cand-preview/cand-card/cand-card.component';
import { CandBasicDataComponent } from './pages/admission/cand-preview/cand-basic-data/cand-basic-data.component';
import { CandSection2Component } from './pages/admission/cand-preview/cand-section2/cand-section2.component';
import { CandSection3Component } from './pages/admission/cand-preview/cand-section3/cand-section3.component';
import { CandSection4Component } from './pages/admission/cand-preview/cand-section4/cand-section4.component';
import { CandPersonalInterviewComponent } from './pages/admission/cand-preview/cand-personal-interview/cand-personal-interview.component';
import { HttpIntercepterBasicAuthService } from './service/http/http-intercepter-basic-auth.service';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { ChartsModule } from 'ng2-charts';
import { CandMedicalCheckComponent } from './pages/admission/cand-preview/cand-medical-check/cand-medical-check.component';
import { CandMoodelTestComponent } from './pages/admission/cand-preview/cand-moodel-test/cand-moodel-test.component';
import { CandEvaluateComponent } from './pages/admission/cand-preview/cand-evaluate/cand-evaluate.component';
import { CreatePasswordComponent } from './pages/create-password/create-password.component';
import { MessagePageComponent } from './pages/message-page/message-page.component';
import { SummaryStatisticsReportComponent } from './pages/reports/summary-statistics-report/summary-statistics-report.component';
import { BulkEnglishTestComponent } from './pages/admission/bulk-english-test/bulk-english-test.component';
import { CandProvinceReportComponent } from './pages/reports/cand-province-report/cand-province-report.component';
import { CoursesComponent } from './pages/enrolment/courses/courses.component';
import { CourseCreateComponent } from './pages/enrolment/courses/course-create/course-create.component';
import { CourseUpdateComponent } from './pages/enrolment/courses/course-update/course-update.component';
import { AcceptedStudentComponent } from './pages/enrolment/accepted-student/accepted-student.component';
import { GradeSubjectComponent } from './pages/enrolment/grade-subject/grade-subject.component';
import { GradeSubjectUpdateComponent } from './pages/enrolment/grade-subject/grade-subject-update/grade-subject-update.component';
import { GradeSubjectCreateComponent } from './pages/enrolment/grade-subject/grade-subject-create/grade-subject-create.component';
import { AddStudentComponent } from './pages/enrolment/add-student/add-student.component';
import { StudentGroupingComponent } from './pages/enrolment/student-grouping/student-grouping.component';
import { EnrolmentReportsComponent } from './pages/enrolment/enrolment-reports/enrolment-reports.component';
import { LectureScheduleSettingsComponent } from './pages/attendence/lecture-schedule-settings/lecture-schedule-settings.component';
import { LectureScheduleSlotsComponent } from './pages/attendence/lecture-schedule-slots/lecture-schedule-slots.component';
import { EnrolmentReportsGroupComponent } from './pages/enrolment/enrolment-reports-group/enrolment-reports-group.component';
import { LectureScheduleSearchComponent } from './pages/attendence/lecture-schedule-search/lecture-schedule-search.component';
import { LectureScheduleFilltableComponent } from './pages/attendence/lecture-schedule-filltable/lecture-schedule-filltable.component';
import { CalenderDayTypeComponent } from './pages/academics/calender-day-type/calender-day-type.component';
import { DayTypeCreateComponent } from './pages/academics/calender-day-type/day-type-create/day-type-create.component';
import { DayTypeUpdateComponent } from './pages/academics/calender-day-type/day-type-update/day-type-update.component';
import { AcademicCalendarComponent } from './pages/academics/academic-calendar/academic-calendar.component';
import { AcademicCalendarCreateComponent } from './pages/academics/academic-calendar/academic-calendar-create/academic-calendar-create.component';
import { AcademicCalendarUpdateComponent } from './pages/academics/academic-calendar/academic-calendar-update/academic-calendar-update.component';
import { TeacherCoursesComponent } from './pages/academics/teacher-courses/teacher-courses.component';
import { TeacherCourseCreateComponent } from './pages/academics/teacher-courses/teacher-course-create/teacher-course-create.component';
import { TeacherCourseUpdateComponent } from './pages/academics/teacher-courses/teacher-course-update/teacher-course-update.component';
import { TeacherComponent } from './pages/academics/teacher/teacher.component';
import { TeacherCreateComponent } from './pages/academics/teacher/teacher-create/teacher-create.component';
import { TeacherUpdateComponent } from './pages/academics/teacher/teacher-update/teacher-update.component';
import { ScheduleSetupComponent } from './pages/schedule/schedule-setup/schedule-setup.component';
import { ScheduleSetupCreateComponent } from './pages/schedule/schedule-setup/schedule-setup-create/schedule-setup-create.component';
import { ScheduleSetupUpdateComponent } from './pages/schedule/schedule-setup/schedule-setup-update/schedule-setup-update.component';
import { ScheduleDetailsComponent } from './pages/schedule/schedule-details/schedule-details.component';
import { ScheduleComponent } from './pages/schedule/schedule/schedule.component';
import { ScheduleCreateComponent } from './pages/schedule/schedule/schedule-create/schedule-create.component';
import { ScheduleUpdateComponent } from './pages/schedule/schedule/schedule-update/schedule-update.component';
import { TypeComponent } from './pages/attendence/type/type.component';
import { TypeCreateComponent } from './pages/attendence/type/type-create/type-create.component';
import { TypeUpdateComponent } from './pages/attendence/type/type-update/type-update.component';
import { AuthorizedAbsenceRequestComponent } from './pages/attendence/authorized-absence-request/authorized-absence-request.component';
import { AbsenceRequestCreateComponent } from './pages/attendence/authorized-absence-request/absence-request-create/absence-request-create.component';
import { DailyAttendanceComponent } from './pages/attendence/daily-attendance/daily-attendance.component';
import { ExamEligibilityComponent } from './pages/attendence/exam-eligibility/exam-eligibility.component';
import { SchedulePreviewComponent } from './pages/schedule/schedule-setup/schedule-preview/schedule-preview.component';
import { ScheduleDetailsPreviewComponent } from './pages/schedule/schedule-details/schedule-details-preview/schedule-details-preview.component';
import { AbsenceRequestUpdateComponent } from './pages/attendence/authorized-absence-request/absence-request-update/absence-request-update.component';
import { AbsenceAssignmentComponent } from './pages/attendence/authorized-absence-request/absence-assignment/absence-assignment.component';
import { AbsenceAssignmentUpdateComponent } from './pages/attendence/authorized-absence-request/absence-assignment/absence-assignment-update/absence-assignment-update.component';
import { YearsComponent } from './pages/academics/years/years.component';
import { YearCreateComponent } from './pages/academics/years/year-create/year-create.component';
import { YearUpdateComponent } from './pages/academics/years/year-update/year-update.component';
import { SemestersComponent } from './pages/academics/semesters/semesters.component';
import { SemesterCreateComponent } from './pages/academics/semesters/semester-create/semester-create.component';
import { SemesterUpdateComponent } from './pages/academics/semesters/semester-update/semester-update.component';
import { AvailableDatesComponent } from './pages/attendence/daily-attendance/available-dates/available-dates.component';
import { AvailableDatesCreateComponent } from './pages/attendence/daily-attendance/available-dates/available-dates-create/available-dates-create.component';
import { CoursesCategoriesComponent } from './pages/academics/courses-categories/courses-categories.component';
import { CourseCategoryCreateComponent } from './pages/academics/courses-categories/course-category-create/course-category-create.component';
import { CourseCategoryUpdateComponent } from './pages/academics/courses-categories/course-category-update/course-category-update.component';
import { MarkGroupComponent } from './pages/academics/mark-group/mark-group.component';
import { MarkGroupCreateComponent } from './pages/academics/mark-group/mark-group-create/mark-group-create.component';
import { MarkGroupUpdateComponent } from './pages/academics/mark-group/mark-group-update/mark-group-update.component';
import { MarksComponent } from './pages/academics/marks/marks.component';
import { MarkCreateComponent } from './pages/academics/marks/mark-create/mark-create.component';
import { MarkUpdateComponent } from './pages/academics/marks/mark-update/mark-update.component';
import { ScoreRankingComponent } from './pages/scores-grades/score-ranking/score-ranking.component';
import { RankingCreateComponent } from './pages/scores-grades/score-ranking/ranking-create/ranking-create.component';
import { RankingUpdateComponent } from './pages/scores-grades/score-ranking/ranking-update/ranking-update.component';
import { AssessmentUnitsComponent } from './pages/scores-grades/assessment-units/assessment-units.component';
import { AssUnitCreateComponent } from './pages/scores-grades/assessment-units/ass-unit-create/ass-unit-create.component';
import { AssUnitUpdateComponent } from './pages/scores-grades/assessment-units/ass-unit-update/ass-unit-update.component';
import { WarningLettersTypeComponent } from './pages/scores-grades/warning-letters-type/warning-letters-type.component';
import { LetterCreateComponent } from './pages/scores-grades/warning-letters-type/letter-create/letter-create.component';
import { LetterUpdateComponent } from './pages/scores-grades/warning-letters-type/letter-update/letter-update.component';
import { ScoresDataUploadComponent } from './pages/scores-grades/scores-data-upload/scores-data-upload.component';
import { ScoresDataCreateComponent } from './pages/scores-grades/scores-data-upload/scores-data-create/scores-data-create.component';
import { CourseAssessmentUnitsComponent } from './pages/scores-grades/course-assessment-units/course-assessment-units.component';
import { CourseAssessmentUnitsCreateComponent } from './pages/scores-grades/course-assessment-units/course-assessment-units-create/course-assessment-units-create.component';
import { CourseAssessmentUnitsUpdateComponent } from './pages/scores-grades/course-assessment-units/course-assessment-units-update/course-assessment-units-update.component';
import { StudentEligiblityComponent } from './pages/scores-grades/student-eligiblity/student-eligiblity.component';
import { WarningLettersComponent } from './pages/scores-grades/warning-letters/warning-letters.component';
import { WarningLetterCreateComponent } from './pages/scores-grades/warning-letters/warning-letter-create/warning-letter-create.component';
import { WarningLetterUpdateComponent } from './pages/scores-grades/warning-letters/warning-letter-update/warning-letter-update.component';
import { LoadStudentsComponent } from './pages/exams/load-students/load-students.component';
import { ReviewAndReleaseComponent } from './pages/exams/review-and-release/review-and-release.component';
import { OngoingExaminationsReviewalComponent } from './pages/exams/ongoing-examinations-reviewal/ongoing-examinations-reviewal.component';
import { FinalExaminationsComponent } from './pages/exams/final-examinations/final-examinations.component';
import { FinalExaminationsCreateComponent } from './pages/exams/final-examinations/final-examinations-create/final-examinations-create.component';
import { CumulativeSheetGenerationComponent } from './pages/exams/cumulative-sheet-generation/cumulative-sheet-generation.component';
import { ReTakeExamComponent } from './pages/exams/re-take-exam/re-take-exam.component';
import { ReTakeExamCreateComponent } from './pages/exams/re-take-exam/re-take-exam-create/re-take-exam-create.component';
import { TestReportComponent } from './pages/reports/test-report/test-report.component';
import { ReportsComponent } from './pages/scores-grades/reports/reports.component';
import { ExamsReportsComponent } from './pages/exams/exams-reports/exams-reports.component';
import { OngoingAssesmentComponent } from './pages/scores-grades/reports/ongoing-assesment/ongoing-assesment.component';
import {NgxPrintModule} from 'ngx-print';
import { SemesterStudentGroupingComponent } from './pages/enrolment/semester-student-grouping/semester-student-grouping.component';
import { SemesterStudentGroupingCreateComponent } from './pages/enrolment/semester-student-grouping/semester-student-grouping-create/semester-student-grouping-create.component';
import { SemesterStudentGroupingUpdateComponent } from './pages/enrolment/semester-student-grouping/semester-student-grouping-update/semester-student-grouping-update.component';
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    PageNotFoundComponent,
    DashboardComponent,
    HeaderComponent,
    ChangePasswordComponent,
    SideNavComponent,
    UsersComponent,
    DatatableComponent,
    LoaderComponent,
    RegistrationComponent,
    CreateUserComponent,
    UserEditComponent,
    CreateProfileComponent,
    LanguageComponent,
    SystemParametersComponent,
    ModuleParametersComponent,
    RolesComponent,
    BasicDataComponent,
    CountriesComponent,
    CreateCountryComponent,
    UpdateCountryComponent,
    RegionsComponent,
    Section1Component,
    ProvincesComponent,
    CreateProvinceComponent,
    UpdateProvinceComponent,
    CreateRegionComponent,
    UpdateRegionComponent,
    Section2Component,
    Section3Component,
    PersonalInterviewComponent,
    MedicalCheckComponent,
    NewCandidateInquiryComponent,
    EvaluateComponent,
    CandEnglishTestComponent,
    ApplicationStatusesComponent,
    ApplicationMaritalStatusComponent,
    CreateMaritalStatusComponent,
    UpdateMaritalStatusComponent,
    LiveWithComponent,
    CreateLiveWithComponent,
    UpdateLiveWithComponent,
    ChronicDiseasesComponent,
    CreateChronicDiseasesComponent,
    UpdateChronicDiseasesComponent,
    CreateAppStatusComponent,
    UpdateAppStatusComponent,
    MilitaryStatusComponent,
    CreateMilitaryStatusComponent,
    UpdateMilitaryStatusComponent,
    FamilyMembersComponent,
    CreateFmMemberComponent,
    UpdateFmMemberComponent,
    QuestionsComponent,
    CreateQuestionComponent,
    UpdateQuestionComponent,
    CreateCityComponent,
    UpdateCityComponent,
    CitiesComponent,
    TestExcelComponent,
    RoleCreateComponent,
    RoleUpdateComponent,
    CandPreviewComponent,
    CandCardComponent,
    CandBasicDataComponent,
    CandSection2Component,
    CandSection3Component,
    CandSection4Component,
    CandPersonalInterviewComponent,
    ErrorPageComponent,
    CandMedicalCheckComponent,
    CandMoodelTestComponent,
    CandEvaluateComponent,
    CreatePasswordComponent,
    MessagePageComponent,
    SummaryStatisticsReportComponent,
    BulkEnglishTestComponent,
    CandProvinceReportComponent,
    CoursesComponent,
    CourseCreateComponent,
    CourseUpdateComponent,
    AcceptedStudentComponent,
    GradeSubjectComponent,
    GradeSubjectUpdateComponent,
    GradeSubjectCreateComponent,
    AddStudentComponent,
    StudentGroupingComponent,
    EnrolmentReportsComponent,
    LectureScheduleSettingsComponent,
    LectureScheduleSlotsComponent,
    EnrolmentReportsGroupComponent,
    LectureScheduleSearchComponent,
    LectureScheduleFilltableComponent,
    CalenderDayTypeComponent,
    DayTypeCreateComponent,
    DayTypeUpdateComponent,
    AcademicCalendarComponent,
    AcademicCalendarCreateComponent,
    AcademicCalendarUpdateComponent,
    TeacherCoursesComponent,
    TeacherCourseCreateComponent,
    TeacherCourseUpdateComponent,
    TeacherComponent,
    TeacherCreateComponent,
    TeacherUpdateComponent,
    ScheduleSetupComponent,
    ScheduleSetupCreateComponent,
    ScheduleSetupUpdateComponent,
    ScheduleDetailsComponent,
    ScheduleComponent,
    ScheduleCreateComponent,
    ScheduleUpdateComponent,
    TypeComponent,
    TypeCreateComponent,
    TypeUpdateComponent,
    AuthorizedAbsenceRequestComponent,
    AbsenceRequestCreateComponent,
    DailyAttendanceComponent,
    ExamEligibilityComponent,
    SchedulePreviewComponent,
    ScheduleDetailsPreviewComponent,
    AbsenceRequestUpdateComponent,
    AbsenceAssignmentComponent,
    AbsenceAssignmentUpdateComponent,
    YearsComponent,
    YearCreateComponent,
    YearUpdateComponent,
    SemestersComponent,
    SemesterCreateComponent,
    SemesterUpdateComponent,
    AvailableDatesComponent,
    AvailableDatesCreateComponent,
    CoursesCategoriesComponent,
    CourseCategoryCreateComponent,
    CourseCategoryUpdateComponent,
    MarkGroupComponent,
    MarkGroupCreateComponent,
    MarkGroupUpdateComponent,
    MarksComponent,
    MarkCreateComponent,
    MarkUpdateComponent,
    ScoreRankingComponent,
    RankingCreateComponent,
    RankingUpdateComponent,
    AssessmentUnitsComponent,
    AssUnitCreateComponent,
    AssUnitUpdateComponent,
    WarningLettersTypeComponent,
    LetterCreateComponent,
    LetterUpdateComponent,
    ScoresDataUploadComponent,
    ScoresDataCreateComponent,
    CourseAssessmentUnitsComponent,
    CourseAssessmentUnitsCreateComponent,
    CourseAssessmentUnitsUpdateComponent,
    StudentEligiblityComponent,
    WarningLettersComponent,
    WarningLetterCreateComponent,
    WarningLetterUpdateComponent,
    LoadStudentsComponent,
    ReviewAndReleaseComponent,
    OngoingExaminationsReviewalComponent,
    FinalExaminationsComponent,
    FinalExaminationsCreateComponent,
    CumulativeSheetGenerationComponent,
    ReTakeExamComponent,
    ReTakeExamCreateComponent,
    TestReportComponent,
    ReportsComponent,
    ExamsReportsComponent,
    OngoingAssesmentComponent,
    SemesterStudentGroupingComponent,
    SemesterStudentGroupingCreateComponent,
    SemesterStudentGroupingUpdateComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    DataTablesModule,
    HttpClientModule,
    NgxPrintModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      closeButton: true,
      extendedTimeOut: 3000,
      timeOut: 3000,
      progressBar: true,
      progressAnimation: 'increasing'
    }),
    TranslateModule.forRoot({
      defaultLanguage: "en",
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    NgMultiSelectDropDownModule,
    ChartsModule,
  ],
  providers: [
    DatePipe,
    Globals,
    loggedInAccess,
    { provide: HTTP_INTERCEPTORS, useClass: HttpIntercepterBasicAuthService, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
